module.exports = __webpack_public_path__ + "static/4-228a7cea4c9f1c3c3db0bdc976a0e5cf.jpeg";